<template>
    <div :class="cssClass" ref="template">
        <div class="grid">
            <cogi-personne
                v-for="(personne, index) in personnes"
                cssClass="grid-full"
                v-model="personnes[index]"
                :key="personne.id!"
                @retirerPersonne="removePersonne(personne.id!)"
                :sourceItemsSexe="sourceItemsSexe"
                :sourceItemsLienParente="sourceItemsLienParente"
                :sourceItemsLienParentesEstSansSousTutelleChefOuConjointPossible="sourceItemsLienParentesEstSansSousTutelleChefOuConjointPossible"
                :sourceItemsPaysNaissance="sourceItemsPaysNaissance"
                :sourceItemsStatutResidence="sourceItemsStatutResidence"
                :sourceItemsSituation="sourceItemsSituation"
                :lienParentePourGardePartagee="lienParentePourGardePartagee"
                :utiliseGardePartagee="utiliseGardePartagee"
                :urlPiece="urlPiece"
                :pourcentageGardePartage="pourcentageGardePartage"
                @validated="personneValidated"
                :valideNow="valideNow"
                :currentIndex="Number(index)"
                :culture="culture">
            </cogi-personne>
            <cogi-button cssClass="grid-full right" cssClassButton="suivant" text="AjouterUnePersonne" @click="addPersonne"></cogi-button>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { ref, watch } from 'vue'
    import { ValidatorAccumulator, ValidationStatutPoco } from './helpers/validatorAccumulator'
    import CogiPersonne from './CogiPersonne.vue'
    import CogiButton from './CogiButton.vue'
    import { del } from '../../../clients/delclient'
    import guid from './helpers/guidgen'

    interface IPropsPersonnes {
        sourceItemsSexe: del.ListItem[]
        sourceItemsLienParente: del.ListItem[]
        sourceItemsLienParentesEstSansSousTutelleChefOuConjointPossible: Array<string>
        sourceItemsPaysNaissance: del.ListItem[]
        sourceItemsStatutResidence: del.ListItem[]
        sourceItemsSituation: del.ListItem[]
        id?: string
        valideNow: boolean
        cssClass: string
        lienParentePourGardePartagee: string
        utiliseGardePartagee: boolean
        urlPiece: string
        pourcentageGardePartage?: number
        culture: string
    }

    const props = withDefaults(defineProps<IPropsPersonnes>(), {})
    const personnes = defineModel<Array<del.PersonneModel>>({ required: true })

    const validator = ref(new ValidatorAccumulator())

    const emit = defineEmits<{
        validated: [boolean]
    }>()

    function addPersonne() {
        const personne = new del.PersonneModel()
        personne.id = guid.GenererGuid()
        personne.prenom = ''
        personne.nom = ''
        personne.sexe = ''
        personne.nas = ''
        personne.lien = ''
        personne.statutDeResidence = ''
        personne.paysDeNaissance = ''
        personne.situation = ''
        personne.revenuTotal = new del.Money()
        personne.etudiantTempsPlein = false
        personne.etudiantTempsPartiel = false
        personne.handicapMoteur = false
        personne.pensionAlimentaire = false
        personne.pensionVeteran = false
        personne.assuranceInvalidite = false

        if (personnes.value == null) personnes.value = []

        personnes.value.push(personne)
    }

    function removePersonne(id: string) {
        personnes.value = personnes.value.filter(personne => personne.id != id)
    }

    function personneValidated(newValue: boolean) {
        let validationStatut: ValidationStatutPoco = validator.value.validated(newValue)

        if (!validationStatut.validationCompleted) return

        emitValidated(validationStatut.hasError)
    }

    function emitValidated(hasError: boolean) {
        emit('validated', hasError)
    }

    watch(
        () => props.valideNow,
        newValue => {
            if (!newValue) return

            let startValidation: boolean = validator.value.startValidation(personnes.value.length)

            if (!startValidation) emitValidated(false)
        },
    )
</script>
